var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { cachedSet } from '../../../utils/utils';
import { head } from '../../../utils/helper/lodash_replacements';
export class ActorMounted {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get isActorMounted() {
        return !!this.componentOfOutermostAspect;
    }
    get componentOfOutermostAspect() {
        return head(this.componentsOfAllRenderedAspects);
    }
    get componentsOfAllRenderedAspects() {
        return this.renderedAspectsFromOuterToInner.map(a => a.aspectMounts.isAspectMounted);
    }
    get outermostRenderedAspect() {
        return head(this.renderedAspectsFromOuterToInner);
    }
    get renderedAspectsFromOuterToInner() {
        return this.renderedAspects.slice().sort((aspect) => {
            const n = aspect.name;
            if (n === 'essence')
                return 0;
            if (n === 'inner')
                return 1;
            if (n === 'outer')
                return 2;
            if (n === 'position')
                return 3;
            return -1;
        });
    }
    get renderedAspects() {
        return this.actor.actorAspects.allAspectsArray.filter(a => a.aspectMounts.isAspectMounted);
    }
}
__decorate([
    computed
], ActorMounted.prototype, "componentOfOutermostAspect", null);
__decorate([
    cachedSet
], ActorMounted.prototype, "componentsOfAllRenderedAspects", null);
__decorate([
    computed
], ActorMounted.prototype, "outermostRenderedAspect", null);
__decorate([
    cachedSet
], ActorMounted.prototype, "renderedAspectsFromOuterToInner", null);
__decorate([
    cachedSet
], ActorMounted.prototype, "renderedAspects", null);
